import { useState, useEffect, useCallback } from 'react';

const STORAGE_KEY = 'barberia_session_v1';

export const usePersistedAuth = () => {
  const [auth, setAuth] = useState(() => {
    // Inicializar desde localStorage
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          // Verificar que no esté expirado (opcional: 24 horas)
          if (parsed.timestamp && Date.now() - parsed.timestamp < 24 * 60 * 60 * 1000) {
            return parsed;
          }
        } catch (e) {
          console.error('Error parsing auth:', e);
        }
      }
    }
    return null;
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const login = useCallback((userData, token) => {
    const session = {
      user: userData,
      token,
      timestamp: Date.now()
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
    setAuth(session);
    
    // Configurar axios si existe
    if (window.axios) {
      window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    setAuth(null);
    if (window.axios) {
      delete window.axios.defaults.headers.common['Authorization'];
    }
  }, []);

  const isAuthenticated = !!auth?.token;

  return {
    user: auth?.user || null,
    token: auth?.token || null,
    login,
    logout,
    isAuthenticated,
    isLoading
  };
};
